const ElectricDefault_Icon = ({style,fill}) => {
    return ( 
        <svg className={"fill-vekin"} width="16" height="16" viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">
<path d="M5.74097 0H9.08165C9.5127 0 9.83599 0.436132 9.72823 0.981298L8.97388 5.56069C8.86612 6.10586 9.18941 6.54199 9.62046 6.54199H11.3447C11.9913 6.54199 12.2068 7.30522 11.7757 7.95942L6.27979 15.8098C6.06426 16.1369 5.52544 16.0279 5.6332 15.5917L6.60308 10.3582C6.71084 9.81299 6.38755 9.37685 5.84873 9.37685L4.77109 9.48589C4.34004 9.59492 3.90898 9.15879 4.01675 8.61362L4.77109 0.981298C4.87886 0.436132 5.30991 0 5.74097 0Z" fill={fill}/>
</svg>

     );
}
 
// add more types here



export const Electricity_Icon = ({style, variant}) => {
    switch(variant){
        case 'default_Green':
            return <ElectricDefault_Icon style={style}/>
        default:
            return <ElectricDefault_Icon style={style} fill="#FFA800"/>
    }
}
 
